<template>
  <div class="conent">
    <div class="page-title" >我的购物车</div>
    <el-table :data="dataList" border @selection-change="selectionChangeHandle">
      <el-table-column type="selection" width="40" label="全选"></el-table-column>
      <!-- <el-table-column type="index" header-align="center" align="center" width="40"></el-table-column> -->
      <el-table-column prop="goodsName" header-align="center" align="center" label="商品"></el-table-column>
      <el-table-column prop="currentPrice" header-align="center" align="center" label="价格" width="100px"></el-table-column>
      <el-table-column prop="num" header-align="center" align="center" label="数量">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.num" @change="handleChange(scope.row.num, scope.$index, scope.row)"
          :disabled="scope.row.goodsCategory!=='realdoc'" :min="1" label="数量"></el-input-number>
          <!--  @blur="handleChange(scope.row.num, scope.$index, scope.row)"  -->
          <!-- <el-tooltip placement="bottom">
            <div slot="content" class="tip">{{scope.row.equipmentType}}</div>
            <div class="demand-desc overell">{{scope.row.equipmentType}}</div>
          </el-tooltip> -->
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="70">
        <template slot-scope="scope">
          <el-button type="text" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-bottom box-shadow">
      <div>总价：<font class="money">￥{{totalMoney}}</font></div>
      <button class="selt-button" @click="settleHandle()">去结算</button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectList: [],
      dataList: [],
      totalMoney: 0
    }
  },
  methods: {
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
      let totalMoney = 0
      list.forEach(item => {
        totalMoney += item.currentPrice * item.num
      })
      this.totalMoney = Math.round(totalMoney * 100) / 100
    },
    getDataList () {
      this.dataList = []
      this.$http.get(`/front/train/trainShoppingCart/list`)
        .then(data => {
          data.data.data.forEach(item => {
            item.originNum = item.num
          })
          this.dataList = data.data.data || []
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    handleChange (val, index, row) {
      // console.log(val, index, row, this.originDataList[index].num)
      if (row.originNum === val) {
        return false
      }
      let upadateIndex = this.selectList.findIndex(item => {
        return item.id === row.id
      })
      if (upadateIndex > -1) {
        this.selectList[upadateIndex].num = val
        let totalMoney = 0
        this.selectList.forEach(item => {
          totalMoney += item.currentPrice * item.num
        })
        this.totalMoney = Math.round(totalMoney * 100) / 100
      }
      this.$http.post(`/front/train/trainShoppingCart/update`, {
        id: row.id,
        num: val,
        operationType: row.originNum > val ? 'reduce' : 'add'
      })
        .then(data => {
          if (data.data.code === 0) {
            this.dataList[index].originNum = val
          } else {
            this.$message.error(data.data.msg)
            this.dataList[index].num = this.dataList[index].originNum
          }
        })
    },
    // 跳转详情
    settleHandle () {
      let ids = this.selectList.map(item => {
        return item.id
      })
      if (ids.length) {
        this.$router.push({ name: 'settlement', query: { goodsId: ids.join('$'), type: 3 } })
      } else {
        this.$message.warning('请选择要结算的数据')
      }
    },
    // 批量删除
    deleteHandle (row) {
      let ids = []
      let goodNames = ''
      if (row) {
        ids.push(row.id)
        goodNames = row.goodsName
      } else {
        ids = this.selectList.map(item => {
          return item.id
        })
        goodNames = this.selectList.map(item => {
          return item.goodsName
        }).join()
      }
      if (ids.length === 0) {
        this.$message.error(this.$t('message.noDeleteData'))
        return false
      }
      this.$confirm(`确定对删除${goodNames}等商品?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$http.post(`/front/train/trainShoppingCart/delete`, {
            ids: ids
          })
            .then(data => {
              if (data && data.data && data.data.code === 0) {
                this.dataList = []
                this.totalPage = 0
                this.getDataList(1)
              } else {
                this.dataList = []
                this.totalPage = 0
                this.$message.error(data.data.msg)
              }
            })
        })
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>
<style scoped>
  .conent{
    padding: 20px 20px;
    position: relative;
  }
  .page-title{
    color: #1D65A8;
    margin: -20px 0 30px;
  }
  /* 分页 */
  /* .doclist-pagination{
    padding-left: 0;
    display: flex;
    justify-content: center;
  } */
  .close-but{
    background: #1D65A8;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 16px;
    margin: 0 auto;
  }
  .demand-desc{
    width: 100%;
    cursor: pointer;
  }
  .tip{
    max-width: 500px;
    word-wrap: break-word;
    word-break: break-all;
  }
  .page-bottom{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    left: 0;
    bottom: -60px;
    height: 50px;
    line-height: 50px;
    width: 100%;
    text-align: right;
  }
  .selt-button{
    cursor: pointer;
    user-select: none;
    margin-right: 20px;
    margin-left: 50px;
    height: 50px;
    border: none;
    background: #1D65A8;
    color: #fff;
    padding: 0 50px;
  }
  .money{
    color: #FF3116;
    letter-spacing: 0.9px;
    font-weight: bold;
  }
</style>
